
export const CALENDAR_LIST_ATTEMPT = "CALENDAR_LIST_ATTEMPT";
export const CALENDAR_LIST_SUCCESS = "CALENDAR_LIST_SUCCESS";
export const CALENDAR_LIST_FAILED = "CALENDAR_LIST_FAILED";
